import { parse } from "postcss";
import React, {useState, useEffect} from "react";

import { API_URL, GET_DOWNLOAD_FILE, POST_ADMIN_FILE_UPLOAD, GET_ADMIN_FILES_RETURN_TABLE } from "../../../constants";
import { ARRAY_EMPTY, GET_TOKEN, OBJECT_EMPTY } from "../../../helpers";
import { LoadingSpinner } from "../../dashboard/partials/LoadingSpinner";
import { ReactTable } from "../../Global/ReactTable/ReactTable";
import { SelectInput } from "../../Global/SelectInput/SelectInput";
import { Modal } from "../../Global/Modal/Modal";
import { Input } from "../../Global/Input/Input";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

// import './AdminReturns.css';
import "./AdminReturns.css";

export const AdminReturns = () => {
  const [returnsType, setReturnsType] = useState('active');
  const [dataLoaded, setDataLoaded] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [modalID, setModalID] = useState('');
  const [vatID, setVatID] = useState('');

  const [returnsData, setReturnsData] = useState([]);
  const [instructionsTextbox, setInstructionsTextbox] = useState('');
  const [statusValues, setStatusValues] = useState({});
  const [rejectionModal, setRejectionModal] = useState(false);
  const [rejection, setRejection] = useState('');

  const [fileDownloadInfo, setFileDownloadInfo] = useState({
    filePath: '', 
    FileName: '', 
    returnId: '',
  });

  const [rareCurrenciesModal, setRareCurrenciesModal] = useState(false);
  const [rareCurrenciesCheckModal, setRareCurrenciesCheckModal] = useState(false);
  const [rareCurrenciesCheckFinished, setRareCurrenciesCheckFinished] = useState(false);

  const [rareCurrencies, setRareCurrencies] = useState([]);

  const [updatedRareCurrencies, setUpdatedRareCurrencies] = useState({});


  const ReturnsTypeSelectBoxValues = [
    {
      label: "Active Returns",
      value: 'active'
    },
    {
      label: "Archived",
      value: 'archive'
    },
  ]

  const ApprovalSelectBoxValues = [
    {
      label: "Waiting for data",
      value: 'created'
    },
    {
      label: "Processing",
      value: 'processing'
    },
    {
      label: "Waiting for approval",
      value: 'waiting_for_approval'
    },
    {
      label: "Aproved",
      value: 'approved'
    },
    {
      label: "Rejected",
      value: 'rejected'
    },
    {
      label: "Submited",
      value: 'submited'
    },
    // {
    //   label: "Checked",
    //   value: 'checked'
    // },
    // {
    //   label: "Created",
    //   value: 'created'
    // },
    // {
    //   label: "Waiting",
    //   value: 'waiting'
    // },
  ]

  const fetchAdminReturnsTable = () => {
    fetch(API_URL + GET_ADMIN_FILES_RETURN_TABLE + `?list=${returnsType}`, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        // typeof response === Array && 
        setReturnsData([...response])
      })
      .catch(err => console.log(err))
      .finally(() => setDataLoaded(true))
  }

  useEffect(() => {
    fetchAdminReturnsTable()
  
    // setDataLoaded(true)
  }, [returnsType, modalActive]);

  useEffect(() => {
    let fetchData = setInterval(() => fetchAdminReturnsTable(), 30000);

    return () => clearInterval(fetchData)
  })

  const getFileBlob = (filePath, FileName, returnId) => {

    fetch(API_URL + `/returns/${returnId}/file/${filePath}`, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
    .then(res => res.blob())
    .then(blob => {
      if (filePath !== undefined ) {
        let file = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
  
        a.setAttribute("id", "temprorary_CVS_link");
        document.body.appendChild(a);
        
        if (!window.navigator.msSaveOrOpenBlob) {
          a.href = file;
          a.download = FileName ? FileName : 'onestopvat.csv';
        }
  
        document.getElementById('temprorary_CVS_link').click()
      }
    })
    .then(() => document.getElementById('temprorary_CVS_link')?.remove())
    .catch(err => console.log(err));
  }

  const preGenerateReturnFile = (rowId) => {
    setRareCurrenciesCheckFinished(false)
    setRareCurrenciesCheckModal(true);

    fetch(API_URL + `/returns/${rowId}/pregenerate`, {
      method: "GET",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
    .then((response) => response.json())
    .then((response) => {
      if (ARRAY_EMPTY(response)) {

        generateReturnFile(rowId)
        setRareCurrenciesCheckFinished(true)

      } else {
        setRareCurrenciesCheckModal(false)
        setVatID(rowId)
        setRareCurrencies(response)
        setRareCurrenciesModal(true)
      }
    })
  }

  const generateReturnFile = (rowId) => {
    let currenciesForPost = [];

    if (!ARRAY_EMPTY(updatedRareCurrencies)) {
      Object.entries(updatedRareCurrencies).map(
        ([, currencyValue]) => {
          return currenciesForPost = [...currenciesForPost, currencyValue]
        }
      );
    }

    fetch(API_URL + `/returns/${rowId}/generate`, {
      method: "POST",
      headers: new Headers({
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: JSON.stringify({
        fx_rate: currenciesForPost
      }),
    })
    .then((response) => response.json())
    .then((response) => {
      let newArray = returnsData

      const returned_item = returnsData.filter((item) => item.id === response.id)
      const old_item_index = returnsData.indexOf(returned_item[0])

      newArray[old_item_index] = response

      setReturnsData([...newArray])
    })
    .catch(err => console.log(err));

    setUpdatedRareCurrencies({})
    setRareCurrenciesModal(false)
  }

  const ReturnsTypeSelectBox = () => {
    return <SelectInput 
      selectValues={ReturnsTypeSelectBoxValues}
      value={ReturnsTypeSelectBoxValues.filter(item => item.value === returnsType)}
      inputValueHandler={(e) => setReturnsType(e.value)}
    />
  }

  const submitInstruction = ( instruction ) => {
    const submitBody = { instruction }

    fetch(API_URL + GET_ADMIN_FILES_RETURN_TABLE + `/${modalID}` , {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: JSON.stringify(submitBody)
    })
    .then(() => {
      setInstructionsTextbox('')
      setModalID('')
      setModalActive(false)
    })
    .catch(error => console.log(error))
  }

  const ApprovalSelectBox = (status, rowId, itemId) => {
    const submitApprovalStatus = (val) => {
        const submitBody = { status: val.value }
        setStatusValues({ ...statusValues, [rowId]: val })

        fetch(API_URL + GET_ADMIN_FILES_RETURN_TABLE + `/${itemId}` , {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: "Bearer " + GET_TOKEN(),
          }),
          body: JSON.stringify(submitBody)
        })
          .then(res => res.json())
          .then(res => {
            fetchAdminReturnsTable()
            // console.log(res)
          })
          .catch(error => console.error(error));
    }

    const selectValue = statusValues[rowId] ? statusValues[rowId] : ApprovalSelectBoxValues.filter(item => item.value === status)[0]

    return <SelectInput 
      // className={status}
      selectValues={ApprovalSelectBoxValues}
      value={selectValue}
      inputValueHandler={(val) => {
        return submitApprovalStatus(val)
      }}
    />
  }

  const fileUpload = (file, returnId) => {
    // if (file.name?.toLowerCase().includes('.csv')) {
      const formData = new FormData();
      formData.append('file[0]', file)
      
      // TODO: not sure if POST_ADMIN_FILE_UPLOAD
      fetch(API_URL + `/returns/${returnId}/file`, {
        method: "POST",
        body: formData,
        headers: new Headers({
          Authorization: "Bearer " + GET_TOKEN(),
        })
      })


        .catch(error => {
          console.error('Error:', error);
        })

    // } else {
    //   console.log('wrong format')
    // }
  }

  const returnsColumns = [
    {
      Header: "Country",
      accessor: "country",
      className: "cell_country",
      Cell: (cell) => {
        return <div className="countryCell">
          <img src={cell.data[cell.row.id].country.img} alt="flag" className="flag-icon-img"/>
          {cell.data[cell.row.id].country.name}
        </div>
      }
    },
    {
      Header: "Return type",
      accessor: "return_type",
      className: "cell_type"
    },
    {
      Header: "Status",
      accessor: "status",
      className: "cell_status",
      Cell: (cell) => {
        let status = cell.data[cell.row.id].status
        let itemId = cell.data[cell.row.id].id

        return ApprovalSelectBox(status, cell.row.id, itemId)
      },
    },
    {
      Header: "Period",
      accessor: "period",
      className: "cell_period"
    },
    {
      Header: "Generate pre-declaration",
      accessor: "pre_declaration",
      className: "cell_pre_declaration",
      Cell: (cell) => {
        let returnId = cell.data[cell.row.id].id
        let generate = cell.data[cell.row.id].generate

        return generate === null
          ? <></>
          : generate === 'new' || generate === 'generated'
            ? <button className='generate_button' onClick={() => preGenerateReturnFile(returnId)}>Generate</button>
            : <>In progress...</>
            
      }
    },
    {
      accessor: "pre_declaration_file",
      className: "cell_cell_pre_declaration_download cell_download",
      Cell: (cell) => {
        let returnId = cell.data[cell.row.id].id
        let generated_file = cell.data[cell.row.id].generate_file

        return generated_file !== null
          ? <button className='download_button' onClick={() => {
              setFileDownloadInfo({
                filePath: generated_file.id, 
                FileName: generated_file.name, 
                returnId: returnId,
              })

              getFileBlob(generated_file.id, generated_file.name, returnId)
            }} />
          : <></>
      }
    },
    {
      Header: "Download",
      accessor: "file_path",
      className: "cell_download",
      Cell: (cell) => {
        let returnId = cell.data[cell.row.id].id
        let rejectionMessage = cell.data[cell.row.id].reject_reason
        let file_info = cell.data[cell.row.id].file

        return file_info !== null
          ? <>              
              <button className='download_button' onClick={() => {
                setFileDownloadInfo({
                  filePath: file_info.id, 
                  FileName: file_info.name, 
                  returnId: returnId,
                })

                getFileBlob(file_info.id, file_info.name, returnId)
              }} />

              {rejectionMessage !== null &&
                <button 
                  className='rejection_button'
                  onClick={() => {
                    setRejection(rejectionMessage)
                    setRejectionModal(true)
                  }}
                >
                  <div className="icon"></div>
                </button>}
            </>
          : <></>

      },
    },
    {
      Header: "Upload",
      accessor: "file_upload",
      className: "cell_download",
      Cell: (cell) => {
        return <label className='file_upload_label'>
          <input
            type='file'
            name='file_upload'
            onChange={(e) => e.target.files !== null && fileUpload(e.target.files[0], cell.data[cell.row.id].id)}
          />
        </label>
      },
    },
  ];

  const ReturnsList = () => {
    return <div className={`returns-list ${(rareCurrenciesCheckModal && rareCurrencies.length <= 0) ? 'rare-currency-active': ''}`}>
      
      <Modal
        ModalOpenHandler={(value) => setRareCurrenciesCheckModal(value)}
        ModalOpen={rareCurrenciesCheckModal}
        ModalBgCloseDisabled={true}
        customClassName={'modal__instructions'}
      >
        <div className="wrapper">
          {
            !rareCurrenciesCheckFinished
              ? (
                  <div className="rare-currency-check-modal full-width">
                    <LoadingSpinner/>
                    <div>Please wait, checking currency rates. Do not close the browser.</div>
                  </div>
                )
              : 
                (
                  <div className="rare-currency-check-modal full-width">
                    <div>No changes required. You can continue using 1stopvat.com</div>
                    <button className="default_button" onClick={() => setRareCurrenciesCheckModal(false)}>OK</button>
                  </div>
                )
              
          }
        </div>
      </Modal>

      <ReactTable className="returnsDataListTable" columns={returnsColumns} data={returnsData} />
    </div>
  }

  const rareCurrencyTableColumns = [
    {
      Header: "Transaction's date",
      accessor: "date",
    },
    {
      Header: "Qnt",
      accessor: "count",
    },
    {
      Header: "Total sum (Gross)",
      accessor: "amount",
    },
    {
      Header: "Original currency",
      accessor: "currency",
    },
    {
      Header: "Converted currency",
      accessor: "converted",
    },
  ]

  return (
    <div className='AdminReturns'>
      <div className="Dashboard__content__top-row">
        <h2> Returns (Admin) </h2>
        {/* <h2 onClick={() => setRareCurrenciesModal(true)}> Returns (Admin) </h2> */}

        <ul className="Dashboard__content__top-row__selectors">
          <li>
            {ReturnsTypeSelectBox()}
          </li>
        </ul>
      </div>

      {dataLoaded 
        ? returnsData.length > 0 ? ReturnsList() : <EmptyData title='You don’t have any returns'/>
        : <LoadingSpinner/>
      }

      {/* Submit Instructions Modal */}
      <Modal
        ModalOpenHandler={(value) => setModalActive(value)}
        ModalOpen={modalActive}
        ModalBgCloseDisabled={true}
        customClassName={'modal__instructions'}
        title={'Add instructions'}
        closeButton
      >
        <form onSubmit={e => {
          e.preventDefault()
          submitInstruction(e.target.instruction_text.value)
        }}>
          <textarea name="instruction_text" id="" cols="30" rows="10"
            value={instructionsTextbox}
            onChange={(e) => setInstructionsTextbox(e.target.value)}
          />

          <div className="button-wrapper">
            <button className='default_button' type="submit">submit</button>
            <button onClick={() => setModalActive(false)}>Cancel</button>
          </div>
        </form>

      </Modal>
      
      {/* Rejection message Modal */}
      <Modal
        ModalOpenHandler={(value) => setRejectionModal(value)}
        ModalOpen={rejectionModal}
        customClassName={'modal__rejection close_right'}
        // title={'Rejection explanation'}
        // closeButton
      > 
        <div className="Modal__title">
          <button type="button" className="close" onClick={() => setRejectionModal(false)}/>
          <h1>Rejection explanation</h1>
        </div>

        <p>{rejection}</p>

      </Modal>

      {/* Rare Currencies Modal */}
      <Modal
        ModalOpenHandler={(value) => setRareCurrenciesModal(value)}
        ModalOpen={rareCurrenciesModal}
        customClassName={'modal__currencies close_right'}
        title={'Currency rate revision needed'}
        closeButton
      >

        <div className="modal__currencies__content">
          <table className="modal__currencies__table default-table">
            <thead>
              <tr>

                {rareCurrencyTableColumns.map(({Header, accessor}, index) => {
                    return <th name={accessor} key={`rare_currency_table_${index}`}>{Header}</th>
                })}

                <th>Fx Rate</th>
              </tr>
            </thead>

            <tbody>

              {rareCurrencies.map((rowItem, rowItemIndex) => {
                return <tr key={rowItem.currency + rowItem.date}>
                  {rareCurrencyTableColumns.map(({ accessor }, index) => {
                    return <td name={accessor} key={rowItem.currency + accessor + index}>{rowItem[accessor]}</td>
                  })}

                  <td className="fx_input">
                    <Input
                      type="number"
                      value={updatedRareCurrencies[rowItem.currency]?.fx_rate ?? ''}
                      inputValueHandler={(value) => setUpdatedRareCurrencies({
                        ...updatedRareCurrencies,
                        [rowItem.currency]: {
                          date: rowItem.date,
                          currency: rowItem.currency,
                          converted: rowItem.converted,
                          fx_rate: value ,
                        }
                      })}
                    />
                  </td>
                </tr>
              })}

            </tbody>
          </table>
        </div>

        <div className="flex modal__currencies__button_wrapper">
          <button 
            className="purple_link"  
            onClick={() => {
              console.log(fileDownloadInfo)

              // initiate download
              generateReturnFile(vatID)
              setRareCurrenciesModal(false)
            }}
          >
            skip rate changing
          </button>

          <button 
            className="default_button"  
            onClick={() => {
              generateReturnFile(vatID)
            }}
          >
            Save rates and continue
          </button>
        </div>

      </Modal>
    </div>
  );
};
